// extracted by mini-css-extract-plugin
export var card = "EmployeeCard-module--card--24UaJ";
export var avatar = "EmployeeCard-module--avatar--IZABj";
export var content = "EmployeeCard-module--content--3tCNj";
export var description = "EmployeeCard-module--description--TegQz";
export var position = "EmployeeCard-module--position--e2VCB";